/**
 * `getCurrentTimeInSeconds` resolves a Unix timestamp in MS to the
 * most recently completed second
 * @returns {number}
 */
function getCurrentTimeInSeconds() {
  return Math.floor(Date.now() / 1000);
}

export default getCurrentTimeInSeconds;



// WEBPACK FOOTER //
// ./features/authentication/utils/getCurrentTimeInSeconds.js